export default __webpack_public_path__ + "static/Hero-mockup-df77c0fa27b121fdefdf57e28692ad71.png";